export default __webpack_public_path__ + "static/media/insta.b6b0f978.svg";